module.exports = __webpack_public_path__ + "static/media/downArrowWhite.032c4d31.svg";